import {animate, state, style, transition, trigger} from '@angular/animations';
import {Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {MatDialog, MatTableDataSource, Sort} from '@angular/material';
import {Router} from '@angular/router';
import moment from 'moment';
import {ToastrService} from 'ngx-toastr';
import {Message} from '../../../../../../core/class/message';
import {CommonService} from '../../../../../../core/services/common.service';
import {WarningComponent} from '../../../../../../shared/components/warning/warning.component';
import {ReportService} from 'src/app/core/services/report.service';
import {TranslateService} from '@ngx-translate/core';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {Subscription} from "rxjs";
import {ResponsiveService} from "../../../../../../core/services/responsive.service";
import {SCREEN_SIZE} from "../../../../../../core/constants/screen-size";
import {CdkDetailRowDirective} from "../../../../../../shared/directive/cdk-detail-row.directive";

@Component({
  selector: 'app-history-report',
  templateUrl: './history-report.component.html',
  styleUrls: ['./history-report.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class HistoryReportComponent implements OnInit, OnChanges {
  @BlockUI() blockUI: NgBlockUI;
  @Input() mode: any;
  @Input() formExport: any;
  @Output() filterForm: EventEmitter<any> = new EventEmitter()
  @Input() singleChildRowDetail: boolean;
  @ViewChild('targetSection', { static: false }) targetSection!: ElementRef;
  displayedColumns: string[] = [];
  columnDefinitions = [
    { def: 'stt', showMobile: true},
    { def: 'reportName',  showMobile: true },
    { def: 'exportDate',  showMobile: false },
    { def: 'exportResult',  showMobile: true },
    { def: 'action',  showMobile: true }
  ];

  data = []

  timeout: any;

  paginate: Paginate;

  dataSource: MatTableDataSource<any>;
  openedRow: CdkDetailRowDirective;

  // sort: {createdTime: string};
  createdTime: string = 'DESC'

  // @ViewChild(MatSort, { static: true }) sort: MatSort;

  reloadFilter: boolean;

  featureStatus: boolean;

  totalCapacity: number = 0;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;


  pageIndex: {
    currentPage: number,
    pageSize: number
  }
  constructor(
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private toast: ToastrService,
    private router: Router,
    private reportService: ReportService,
    private responsiveService: ResponsiveService,
    private translateService: TranslateService
  ) {
    // this.sort.createdTime = "ASC";
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['formExport'].firstChange) {
      this.createExport();
    } else {
    }
  }

  createExport(isDownload?: boolean) {
    window.scrollTo(0, 0);
    this.blockUI.reset();
    this.blockUI.start('');
    this.paginate.currentPage = 0;
    this.paginate.pageSize = 10;
    this.createdTime = 'DESC';
    if (isDownload) {
      if (this.formExport.signedFromDate){
        this.formExport.signedFromDate = moment(this.formExport.signedFromDate).format('YYYY-MM-DD');
      }
      if (this.formExport.signedToDate){
        this.formExport.signedToDate = moment(this.formExport.signedToDate).format('YYYY-MM-DD');
      }
      if (this.formExport.createdFromDate) {
        this.formExport.createdFromDate = moment(this.formExport.createdFromDate).format('YYYY-MM-DD');
      }
      if (this.formExport.createdToDate) {
        this.formExport.createdToDate = moment(this.formExport.createdToDate).format('YYYY-MM-DD');
      }
      if (this.formExport.receiveFromDate) {
        this.formExport.receiveFromDate = moment(this.formExport.receiveFromDate).format('YYYY-MM-DD');
      }
      if (this.formExport.receiveToDate) {
        this.formExport.receiveToDate = moment(this.formExport.receiveToDate).format('YYYY-MM-DD');
      }
      if (this.formExport.expiredFromDate) {
        this.formExport.expiredFromDate = moment(this.formExport.expiredFromDate).format('YYYY-MM-DD');
      }
      if (this.formExport.expiredToDate) {
        this.formExport.expiredToDate = moment(this.formExport.expiredToDate).format('YYYY-MM-DD');
      }
    }
    this.timeout = setTimeout(() => {
      switch (this.mode) {
        case 1: {
          const formFilter = {
            contractPersonalCreateSearchFilter: this.formExport
          }
          this.reportService.exportContractPersonalCreateQuantity(formFilter).subscribe(rs => {
            if (rs.success) {
              this.initData(this.paginate);
            } else {
              this.toast.error(rs.message);
            }
          }, err => {
            this.toast.error(this.translateService.instant('toastr_report.export_false'));
          });
          break;
        }
        case 2: {
          const formFilter = {
            contractEnterpriseCreateSearchFilter: this.formExport
          }
          this.reportService.exportContractEnterpriseCreateQuantity(formFilter).subscribe(rs => {
            if (rs.success) {
              this.initData(this.paginate);
            } else {
              this.toast.error(rs.message);
            }
          }, err => {
            this.toast.error(this.translateService.instant('toastr_report.export_false'));
          });
          break;
        }
        case 3: {
          const formFilter = {
            contractEnterpriseReceiveSearchFilter: this.formExport
          }
          this.reportService.exportContractEnterpriseReceiveQuantity(formFilter).subscribe(rs => {
            if (rs.success) {
              this.initData(this.paginate);
            } else {
              this.toast.error(rs.message);
            }
          }, err => {

            this.toast.error(this.translateService.instant('toastr_report.export_false'));
          });
          break;
        }
        case 4:
        case 5:
        case 6: {
          if (isDownload) {
            this.formExport.totalReportSearch.fromDate = moment(this.formExport.totalReportSearch.fromDate).format('YYYY-MM-DD');
            this.formExport.totalReportSearch.toDate = moment(this.formExport.totalReportSearch.toDate).format('YYYY-MM-DD');
          }
          const formFilter = isDownload ? this.formExport.totalReportSearch : this.formExport.value
          this.reportService.exportTotalContract(formFilter, this.mode).subscribe(rs => {
            if (rs.success) {
              this.blockUI.stop()
              this.initData(this.paginate);
            } else {
              this.blockUI.stop()
              this.toast.error(rs.message);
            }
          }, err => {
            this.blockUI.stop()
            this.toast.error(this.translateService.instant('toastr_report.export_false'));
          });
          break;
        }
        case 7: {
          if (isDownload) {
            this.formExport.totalReportSearch.fromDate = moment(this.formExport.totalReportSearch.fromDate).format('YYYY-MM-DD');
            this.formExport.totalReportSearch.toDate = moment(this.formExport.totalReportSearch.toDate).format('YYYY-MM-DD');
          }
          const formFilter = isDownload ? this.formExport.totalReportSearch : this.formExport.value
          this.reportService.exportEndorsementMoney(formFilter).subscribe(rs => {
            if (rs.success) {
              this.blockUI.stop()
              this.initData(this.paginate);
            } else {
              this.blockUI.stop()
              this.toast.error(rs.message);
            }
          }, err => {
            this.blockUI.stop()
            this.toast.error(this.translateService.instant('toastr_report.export_false'));
          });
          break;
        }
        case 8: {
          if (isDownload) {
            this.formExport.totalReportSearch.fromDate = moment(this.formExport.totalReportSearch.fromDate).format('YYYY-MM-DD');
            this.formExport.totalReportSearch.toDate = moment(this.formExport.totalReportSearch.toDate).format('YYYY-MM-DD');
          }
          const formFilter = isDownload ? this.formExport.totalReportSearch : this.formExport.value
          this.reportService.exportTimestampQuantity(formFilter).subscribe(rs => {
            if (rs.success) {
              this.blockUI.stop()
              this.initData(this.paginate);
            } else {
              this.blockUI.stop()
              this.toast.error(rs.message);
            }
          }, err => {
            this.blockUI.stop()
            this.toast.error(this.translateService.instant('toastr_report.export_false'));
          });
          break;
        }
        case 10: {
          const formFilter = {
            contractByUserFilter: this.formExport
          }
          this.reportService.exportContractByUserCreate(formFilter).subscribe(rs => {
            if (rs.success) {
              this.blockUI.stop()
              this.initData(this.paginate);
            } else {
              this.blockUI.stop()
              this.toast.error(rs.message);
            }
          }, err => {
            this.blockUI.stop()
            this.toast.error(this.translateService.instant('toastr_report.export_false'));
          });
          break;
        }
        case 11: {
          const formFilter = {
            contractProcessing: this.formExport
          }
          this.reportService.exportProcessingContract(formFilter).subscribe(rs => {
            if (rs.success) {
              this.blockUI.stop()
              this.initData(this.paginate);
            } else {
              this.blockUI.stop()
              this.toast.error(rs.message);
            }
          }, err => {
            this.blockUI.stop()
            this.toast.error(this.translateService.instant('toastr_report.export_false'));
          });
          break;
        }
        case 12: {
          if (isDownload) {
            this.formExport.totalReportSearch.fromDate = moment(this.formExport.totalReportSearch.fromDate).format('YYYY-MM-DD');
            this.formExport.totalReportSearch.toDate = moment(this.formExport.totalReportSearch.toDate).format('YYYY-MM-DD');
          }
          const formFilter = this.formExport.totalReportSearch
          this.reportService.exportSmsHistoryReport(formFilter).subscribe(rs => {
            if (rs.success) {
              this.blockUI.stop()
              this.initData(this.paginate);
            } else {
              this.blockUI.stop()
              this.toast.error(rs.message);
            }
          }, err => {
            this.blockUI.stop()
            this.toast.error(this.translateService.instant('toastr_report.export_false'));
          });
          break;
        }
      }
    }, 1000)
  }
  getDisplayedColumns() {
    if (
      this.mediaBreakpoint === SCREEN_SIZE.XS ||
      this.mediaBreakpoint === SCREEN_SIZE.SM
    ) {
      this.displayedColumns = this.columnDefinitions
        .filter((cd) => cd.showMobile)
        .map((cd) => cd.def);
    }
    else {
      this.displayedColumns = this.columnDefinitions.map((cd) => cd.def);
    }
  }

  ngAfterViewInit() {
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }


  initData(pageData: Paginate) {
    // this.timeout = setTimeout(() =>{
    //
    // }, 15000)

    const href = this.router.url;
    let filter = {
      page: pageData.currentPage,
      pageSize: pageData.pageSize,
      sorts: { createdTime: this.createdTime }
    }
    if (href.includes('contract-personal-create')) {
      this.reportService.filterPersonalContract(filter).subscribe(rs => {
        if (rs.success) {
          this.blockUI.stop();
          this.getDataTable(rs.data);
        } else
          this.toast.error(rs.message);
      }, err => {
        this.toast.error(err.message);
      });
    } else if (href.includes('contract-enterprise-create')) {
      this.reportService.filterEnterpriseContract(filter).subscribe(rs => {
        if (rs.success) {
          this.getDataTable(rs.data);
        } else
          this.toast.error(rs.message);
      }, err => {
        this.toast.error(err.message);
      });
    } else if (href.includes('contract-enterprise-receive')) {
      this.reportService.filterEnterpriseReceive(filter).subscribe(rs => {
        if (rs.success) {
          this.getDataTable(rs.data);
        } else
          this.toast.error(rs.message);
      }, err => {
        this.toast.error(err.message);
      });
    } else if (href.includes('certificate-money-report')) {
      this.reportService.filterEndorsementMoney(filter).subscribe(rs => {
        if (rs.success) {
          this.getDataTable(rs.data);
        } else
          this.toast.error(rs.message);
      }, err => {
        this.toast.error(err.message);
      });
    } else if (href.includes('timestamp-quantity-report')) {
      this.reportService.filterTimestampQuantity(filter).subscribe(rs => {
        if (rs.success) {
          this.getDataTable(rs.data);
        } else
          this.toast.error(rs.message);
      }, err => {
        this.toast.error(err.message);
      });
    } else if (href.includes('contract-processing')) {
      this.reportService.filterProcessingContract(filter).subscribe(rs => {
        if (rs.success) {
          this.getDataTable(rs.data);
        } else
          this.toast.error(rs.message);
      }, err => {
        this.toast.error(err.message);
      });
    } else if (href.includes('sms-history-report')) {
      this.reportService.filterSmsHistoryReport(filter).subscribe(rs => {
        if (rs.success) {
          this.getDataTable(rs.data);
        } else
          this.toast.error(rs.message);
      }, err => {
        this.toast.error(err.message);
      });
    } else {
      this.reportService.filterTotalContract(this.mode, filter).subscribe(rs => {
        if (rs.success) {
          this.getDataTable(rs.data);
        } else
          this.toast.error(rs.message);
      }, err => {
        this.toast.error(err.message);
      });
    }
  }


  ngOnInit() {
    this.initData(this.paginate);
    this.columnDefinitions.forEach(item => {
      this.displayedColumns.push(item.def);
    });

  }
  onToggleChange(cdkDetailRow: CdkDetailRowDirective, row): void {
    if (this.singleChildRowDetail && this.openedRow && this.openedRow.expended) {
      this.openedRow.toggle();
    }

    if (!row.close) {
      row.close = true;
    } else {
      row.close = false;
    }
    this.openedRow = cdkDetailRow.expended ? cdkDetailRow : undefined;
  }

  getDataTable($event: any) {
    const dataSource = $event.content;

    // dataSource.map(item => {
    //   item.effectiveDate = item.effectiveDate ? moment(item.effectiveDate, 'MMM DD, YYYY HH:mm:ss A').format('DD/MM/YYYY') : '';
    //   item.expireDate = item.expireDate ? moment(item.expireDate, 'MMM DD, YYYY HH:mm:ss A').format('DD/MM/YYYY') : '';
    // });

    this.dataSource = new MatTableDataSource<any>(dataSource);
    // this.dataSource.sort = this.sort;
    this.pageIndex = {
      pageSize: $event.pageable.size,
      currentPage: $event.pageable.page
    }
    this.paginate = {
      pageSize: $event.pageable.size,
      currentPage: $event.pageable.page,
      totalRow: $event.total,
      totalPage: Math.ceil($event.total / $event.pageable.size),
      totalPageArray: this.counter(Math.ceil($event.total / $event.pageable.size), 1),
      no: this.counter($event.pageable.size, $event.pageable.page * $event.pageable.size + 1)
    };
  }

  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }

  onChangePage(e: any) {
    this.paginate.currentPage = e.page ? e.page : 0;
    this.paginate.pageSize = e.pageSize;
    this.initData(this.paginate);
  }

  onChangeSort(e: Sort) {
    if (e.direction === '') {
      return;
    }
    this.createdTime = e.direction.toUpperCase()
    this.initData(this.paginate);
  }

  downloadContract(id, filename) {
    switch (this.mode) {
      case 1: {
        this.reportService.checkDownloadPersonalContract(id).subscribe(rs => {
          if (rs && rs.message) {
            this.toast.error(rs.message);
          } else
            this.reportService.downloadPersonalContract(id).subscribe(rs => {
              if (rs) {
                this.toast.success(this.translateService.instant('toastr_report.download_success'));
                this.downLoadFile(rs, 'application/vnd.openxmlformats officedocument.spreadsheetml.sheet', filename);
              } else
                this.toast.error(rs.message);
            });
        });
        break;
      }
      case 2: {
        this.reportService.checkDownloadEnterpriseContract(id).subscribe(rs => {
          if (rs && rs.message) {
            this.toast.error(rs.message);
          } else
            this.reportService.downloadEnterpriseContract(id).subscribe(rs => {
              if (rs) {
                this.toast.success(this.translateService.instant('toastr_report.download_success'));
                this.downLoadFile(rs, 'application/vnd.openxmlformats officedocument.spreadsheetml.sheet', filename);
              } else
                this.toast.error(rs.message);
            });
        });
        break;
      }
      case 3: {
        this.reportService.checkDownloadEnterpriseReceive(id).subscribe(rs => {
          if (rs && rs.message) {
            this.toast.error(rs.message);
          } else
            this.reportService.downloadEnterpriseReceive(id).subscribe(rs => {
              if (rs) {
                this.toast.success(this.translateService.instant('toastr_report.download_success'));
                this.downLoadFile(rs, 'application/vnd.openxmlformats officedocument.spreadsheetml.sheet', filename);
              } else
                this.toast.error(rs.message);
            });
        });
        break;
      }
      case 4:
      case 5:
      case 6: {
        this.reportService.checkDownloadTotalContract(this.mode, id).subscribe(rs => {
          if (rs && rs.message) {
            this.toast.error(rs.message);
          } else
            this.reportService.downloadTotalContract(this.mode, id).subscribe(rs => {
              this.toast.success(this.translateService.instant('toastr_report.download_success'));
              this.downLoadFile(rs, 'application/vnd.openxmlformats officedocument.spreadsheetml.sheet', filename)
            });
        });
        break;
      }
      case 7: {
        this.reportService.checkDownloadEndorsementMoney(id).subscribe(rs => {
          if (rs && rs.message) {
            this.toast.error(rs.message);
          } else
            this.reportService.downloadEndorsementMoney(id).subscribe(rs => {
              this.toast.success(this.translateService.instant('toastr_report.download_success'));
              this.downLoadFile(rs, 'application/vnd.openxmlformats officedocument.spreadsheetml.sheet', filename)
            });
        });
        break;
      }
      case 8: {
        this.reportService.checkDownloadTimestampQuantity(id).subscribe(rs => {
          if (rs && rs.message) {
            this.toast.error(rs.message);
          } else
            this.reportService.downloadTimestampQuantity(id).subscribe(rs => {
              this.toast.success(this.translateService.instant('toastr_report.download_success'));
              this.downLoadFile(rs, 'application/vnd.openxmlformats officedocument.spreadsheetml.sheet', filename)
            });
        });
        break;
      }
      case 10: {
        this.reportService.checkDownloadTotalContract(this.mode, id).subscribe(rs => {
          if (rs && rs.message) {
            this.toast.error(rs.message);
          } else
            this.reportService.downloadTotalContract(this.mode, id).subscribe(rs => {
              this.toast.success(this.translateService.instant('toastr_report.download_success'));
              this.downLoadFile(rs, 'application/vnd.openxmlformats officedocument.spreadsheetml.sheet', filename)
            });
        });
        break;
      }
      case 11: {
        this.reportService.checkDownloadProcessingContract(id).subscribe(rs => {
          if (rs && rs.message) {
            this.toast.error(rs.message);
          } else
            this.reportService.downloadProcessingContract(id).subscribe(rs => {
              this.toast.success(this.translateService.instant('toastr_report.download_success'));
              this.downLoadFile(rs, 'application/vnd.openxmlformats officedocument.spreadsheetml.sheet', filename)
            });
        });
        break;
      }
      case 12: {
        this.reportService.checkDownloadSmsHistoryReport(id).subscribe(rs => {
          if (rs && rs.message) {
            this.toast.error(rs.message);
          } else
            this.reportService.downloadSmsHistoryReport(id).subscribe(rs => {
              this.toast.success(this.translateService.instant('toastr_report.download_success'));
              this.downLoadFile(rs, 'application/vnd.openxmlformats officedocument.spreadsheetml.sheet', filename)
            });
        });
        break;
      }
    }
  }
  renderStatus(status: any) {
    switch (status) {
      case 3:
        return this.message.getMessage('history_report.status.error');
      case 1:
        return this.message.getMessage('history_report.status.process');
      case 2:
        return this.message.getMessage('history_report.status.done');
      default:
        return '';
    }
  }

  renderStatusColor(status: any): object {
    switch (status) {
      case 3:
        return { 'color': 'red', 'border': '1px solid red', 'border-radius': '5px' };
      case 1:
        return { 'color': 'blue', 'border': '1px solid blue', 'border-radius': '5px' };
      default:
        return { 'color': 'green', 'border': '1px solid green', 'border-radius': '5px' };
    }
  }


  deleteContract(id, name) {
    if (this.dataSource.filteredData.length === 1 && this.paginate.currentPage > 0) {
      this.paginate.currentPage--
    }
    const dialogConfirm = this.dialog.open(WarningComponent, {
      data: this.commonService.format(this.message.getMessage('messages.delete_report'), name),
      width: '40%'
    });
    dialogConfirm.afterClosed().subscribe(rs => {
      if (rs) {
        switch (this.mode) {
          case 1: {
            this.reportService.deletePersonalContract(id).subscribe(rs => {
              if (rs.success) {
                this.toast.success(this.translateService.instant('toastr_report.delete_report_success'));
                this.initData(this.paginate)
              } else
                this.toast.error(rs.message);
            });
            break;
          }
          case 2: {
            this.reportService.deleteEnterpriseContract(id).subscribe(rs => {
              if (rs.success) {
                this.toast.success(this.translateService.instant('toastr_report.delete_report_success'));
                this.initData(this.paginate)
              } else
                this.toast.error(rs.message);
            });
            break;
          }
          case 3: {
            this.reportService.deleteEnterpriseReceive(id).subscribe(rs => {
              if (rs.success) {
                this.toast.success(this.translateService.instant('toastr_report.delete_report_success'));
                this.initData(this.paginate)
              } else
                this.toast.error(rs.message);
            });
            break;
          }
          case 4:
          case 5:
          case 6: {
            this.reportService.deleteTotalContract(this.mode, id).subscribe(rs => {
              if (rs.success) {
                this.toast.success(this.translateService.instant('toastr_report.delete_report_success'));
                this.initData(this.paginate)
              } else
                this.toast.error(rs.message);
            });
            break;
          }
          case 7: {
            this.reportService.deleteEndorsementMoney(id).subscribe(rs => {
              if (rs.success) {
                this.toast.success(this.translateService.instant('toastr_report.delete_report_success'));
                this.initData(this.paginate)
              } else
                this.toast.error(rs.message);
            });
            break;
          }
          case 8: {
            this.reportService.deleteTimestampQuantity(id).subscribe(rs => {
              if (rs.success) {
                this.toast.success(this.translateService.instant('toastr_report.delete_report_success'));
                this.initData(this.paginate)
              } else
                this.toast.error(rs.message);
            });
            break;
          }
          case 10: {
            this.reportService.deleteTotalContract(this.mode, id).subscribe(rs => {
              if (rs.success) {
                this.toast.success(this.translateService.instant('toastr_report.delete_report_success'));
                this.initData(this.paginate)
              } else
                this.toast.error(rs.message);
            });
            break;
          }
          case 11: {
            this.reportService.deleteProcessingContract(id).subscribe(rs => {
              if (rs.success) {
                this.toast.success(this.translateService.instant('toastr_report.delete_report_success'));
                this.initData(this.paginate)
              } else
                this.toast.error(rs.message);
            });
            break;
          }
          case 12: {
            this.reportService.deleteSmsHistoryReport(id).subscribe(rs => {
              if (rs.success) {
                this.toast.success(this.translateService.instant('toastr_report.delete_report_success'));
                this.initData(this.paginate)
              } else
                this.toast.error(rs.message);
            });
            break;
          }
        }
      }
    });

  }

  viewFilterFile(data: any, isDownload?: boolean) {
    // this.filterForm.emit(this.formExport);
    switch (this.mode) {
      case 1: {
        this.reportService.viewPersonalContract(data.id).subscribe(rs => {
          if (rs.success) {
            if (isDownload) {
              this.formExport = rs.data.contractPersonalCreateSearchFilter;
              this.reDownload();
            } else {
              this.filterForm.emit(rs.data);
            }
          } else
            this.toast.error(rs.message);
        });
        break;
      }
      case 2: {
        this.reportService.viewEnterpriseContract(data.id).subscribe(rs => {
          if (rs.success) {
            if (isDownload) {
              this.formExport = rs.data.contractEnterpriseCreateSearchFilter;
              this.reDownload();
            } else {
              this.filterForm.emit(rs.data);
            }
          } else
            this.toast.error(rs.message);
        });
        break;
      }
      case 3: {
        this.reportService.viewEnterpriseReceive(data.id).subscribe(rs => {
          if (rs.success) {
            if (isDownload) {
              this.formExport = rs.data.contractEnterpriseReceiveSearchFilter;
              this.reDownload();
            } else {
              this.filterForm.emit(rs.data);
            }
          } else
            this.toast.error(rs.message);
        });
        break;
      }
      case 4:
      case 5:
      case 6: {
        this.reportService.viewTotalContract(this.mode, data.id).subscribe(rs => {
          if (rs.success) {
            if (isDownload) {
              this.formExport = rs.data;
              this.reDownload();
            } else {
              this.filterForm.emit(rs.data);
            }
          } else
            this.toast.error(rs.message);
        });
        break;
      }
      case 7: {
        this.reportService.viewEndorsementMoney(data.id).subscribe(rs => {
          if (rs.success) {
            if (isDownload) {
              this.formExport = rs.data;
              this.reDownload();
            } else {
              this.filterForm.emit(rs.data);
            }
          } else
            this.toast.error(rs.message);
        });
        break;
      }
      case 8: {
        this.reportService.viewTimestampQuantity(data.id).subscribe(rs => {
          if (rs.success) {
            if (isDownload) {
              this.formExport = rs.data;
              this.reDownload();
            } else {
              this.filterForm.emit(rs.data);
            }
          } else
            this.toast.error(rs.message);
        });
        break;
      }
      case 10: {
        this.reportService.viewTotalContract(this.mode, data.id).subscribe(rs => {
          if (rs.success) {
            if (isDownload) {
              this.formExport = rs.data;
              this.reDownload();
            } else {
              const dataSearch = {
                data:rs.data,
                ngay:data.createdTime
              }
              this.filterForm.emit(dataSearch);
            }
          } else
            this.toast.error(rs.message);
        });
        break;
      }
      case 11: {
        this.reportService.viewProcessingContractReport(data.id).subscribe(rs => {
          if (rs.success) {
            if (isDownload) {
              this.formExport = rs.data;
              this.reDownload();
            } else {
              this.filterForm.emit(rs.data);
            }
          } else
            this.toast.error(rs.message);
        });
        break;
      }
      case 12: {
        break;
      }
    }
  }

  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], { type });
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  reDownload() {
    this.paginate.currentPage = 0;
    this.createExport(true);
  }

}
export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: [];
  no: [];
}
